export default __webpack_public_path__ + "static/media/drum.b47f6296.jpg";